
import { useCallback } from "react";

interface ActionButtonState {
  isActive: boolean;
  isDeselected: boolean;
  isHovered: boolean;
  isDisabled: boolean;
  setIsHovered: (value: boolean) => void;
  onClick: (e: React.MouseEvent) => Promise<void>;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

interface UseButtonPropsGeneratorProps {
  favoriteVisualState: any;
  planToWatchVisualState: any;
  favoriteState: {
    isHovered: boolean;
    isDeselected: boolean;
    setIsHovered: (value: boolean) => void;
    setIsDeselected: (value: boolean) => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
  watchlistState: {
    isHovered: boolean;
    isDeselected: boolean;
    setIsHovered: (value: boolean) => void;
    setIsDeselected: (value: boolean) => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
  handleFavoriteClick: (e: React.MouseEvent) => Promise<void>;
  handlePlanToWatchClick: (e: React.MouseEvent) => Promise<void>;
}

/**
 * Hook to generate button props for favorite and watchlist buttons
 */
export const useButtonPropsGenerator = ({
  favoriteVisualState,
  planToWatchVisualState,
  favoriteState,
  watchlistState,
  handleFavoriteClick,
  handlePlanToWatchClick
}: UseButtonPropsGeneratorProps) => {
  
  const getFavoriteButtonProps = useCallback((): ActionButtonState => ({
    isActive: favoriteVisualState.currentValue,
    isDeselected: favoriteState.isDeselected,
    isHovered: favoriteState.isHovered,
    isDisabled: false,
    setIsHovered: favoriteState.setIsHovered,
    onClick: handleFavoriteClick,
    onMouseEnter: favoriteState.onMouseEnter,
    onMouseLeave: favoriteState.onMouseLeave
  }), [favoriteVisualState.currentValue, favoriteState, handleFavoriteClick]);

  const getPlanToWatchButtonProps = useCallback((): ActionButtonState => ({
    isActive: planToWatchVisualState.currentValue,
    isDeselected: watchlistState.isDeselected,
    isHovered: watchlistState.isHovered,
    isDisabled: false,
    setIsHovered: watchlistState.setIsHovered,
    onClick: handlePlanToWatchClick,
    onMouseEnter: watchlistState.onMouseEnter,
    onMouseLeave: watchlistState.onMouseLeave
  }), [planToWatchVisualState.currentValue, watchlistState, handlePlanToWatchClick]);

  return {
    getFavoriteButtonProps,
    getWatchlistButtonProps: getPlanToWatchButtonProps
  };
};
